import {TeamRestDto} from "@/api/pharma-cms-pharmacy/models";
import {StatusEnum} from "@/api/enums/status-enum";
import {MultilingualRestDtoModel} from "@/models/MultilingualRestDtoModel";

export class TeamRestDtoModel implements TeamRestDto {
    title: MultilingualRestDtoModel;
    content: MultilingualRestDtoModel;
    image_key: MultilingualRestDtoModel;
    status_code: StatusEnum;

    constructor(title: MultilingualRestDtoModel, content: MultilingualRestDtoModel, image_key: MultilingualRestDtoModel, status_code: StatusEnum) {
        this.title = title;
        this.content = content;
        this.image_key = image_key;
        this.status_code = status_code;
    }

    public static createWithDefaults(): TeamRestDtoModel {
        return new TeamRestDtoModel(
            MultilingualRestDtoModel.createWithDefaults(),
            MultilingualRestDtoModel.createWithDefaults(),
            MultilingualRestDtoModel.createWithDefaults(),
            StatusEnum.PUBLISHED
        );
    }
}
